import { cardNode } from "../fragments/cardNode";

export const relatedItemsVideoContentItemsQuery = (algorithmId) => {
    return `query relatedVideoContentItems($sourceId: String!, $formats: [String], $first: Int${
        algorithmId ? ", $algorithmId: String" : ""
    }) {
        relatedItems(sourceId: $sourceId, formats: $formats, first: $first${
            algorithmId ? ", algorithmId: $algorithmId" : ""
        }) {
            nodes {
                ...cardNode
            }
        }
    }${cardNode}`;
};

export const relatedItemsQuery = (polopolyId, algorithmId = null) => {
    return `
        query {
            relatedItems ( sourceId: "${polopolyId}", ${
        algorithmId ? 'algorithmId: "' + algorithmId + '",' : ""
    } first: 5, formats: ["story"],) {
                nodes {
                    title
                    type
                    sourceId
                    url
                }
            }
        }
    `;
};
